export type ExperimentName = (typeof allExperimentNames)[number]

export type GateName = 'pay_pal_partner' | 'pay_pal_vault_toggle_ns' | ''
export type DynamicConfigName =
  | 'user_browser'
  | 'user_country'
  | 'payment_method_orchestrator_config'
  | 'recaptcha_config'
  | 'express_checkout_config'
export type LayerName = ''

export const allExperimentNames = [
  'shop__ab_first_rate_strategy_pricing_plan_selector',
  'shop__ab_express_checkout_paypal_combined_module',
  'payer_aa_events_validation',
] as const
